import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("Полето е задължително."),
  middleName: Yup.string().nullable(),
  lastName: Yup.string().required("Полето е задължително."),
  firstNameEn: Yup.string().required("Полето е задължително."),
  middleNameEn: Yup.string().nullable(),
  lastNameEn: Yup.string().required("Полето е задължително."),
  userEmail: Yup.string().email("Невалиден имейл адрес.").nullable(),
  email: Yup.string().email("Невалиден имейл адрес.").required("Полето е задължително."),
  phone: Yup.string().required("Полето е задължително."),
  citizenshipCountryId: Yup.string().required("Полето е задължително."),
  secondaryCitizenshipCountryId: Yup.string().nullable(),
  identificationTypeId: Yup.string().required("Полето е задължително."),
  egn: Yup.string().required("Полето е задължително."),
  sexId: Yup.string().required("Полето е задължително."),
  birthCountryId: Yup.number().required("Полето е задължително."),
  birthCityId: Yup.string().when("birthCountryId", {
    is: 22,
    then: (schema) => schema.required("Полето е задължително."),
    otherwise: (schema) => schema.nullable(),
  }),
  birthDate: Yup.string().required("Полето е задължително."),
  facultyId: Yup.string().required("Полето е задължително."),
  specialityId: Yup.string().required("Полето е задължително."),
  admissionReasonId: Yup.string().required("Полето е задължително."),
  degreeId: Yup.string().required("Полето е задължително."),
  specialityModeId: Yup.string().required("Полето е задължително."),
  semester: Yup.string().required("Полето е задължително."),
  studentStatusId: Yup.string().required("Полето е задължително."),
  specialityTypeId: Yup.string().required("Полето е задължително."),
});

export default validationSchema;
